
import * as types from '../mutation-types'
import localStorage from 'store'
import tracking from '@/api/tracking'

const UTM_PARAMS_KEY = 'utm_params'
const UTM_TRACKED_KEY = 'utm_tracked'

const state = {
  data: {
    utmSource: null,
    utmMedium: null,
    utmCampaign: null,
    utmTerm: null,
    utmContent: null,
    action: null,
    signupMethod: null,
    query: null,
    userAgent: null,
    referrer: null
  },
  utmTracked: false
}

const getters = {
  utmParams: (state) => {
    return state.data
  },
  utmTracked: (state) => {
    return state.tracked
  }
}

// actions
const actions = {
  initializeUtmFromLocalStorage ({ commit }) {
    commit(types.INITIALIZE_UTM_FROM_LOCAL_STORAGE)
  },
  setUtmParams ({ commit }, { utmSource, utmMedium, utmCampaign, utmTerm, utmContent, query, userAgent, referrer }) {
    commit(types.SET_UTM_PARAM, { utmSource, utmMedium, utmCampaign, utmTerm, utmContent, query, userAgent, referrer })
  },
  clearUtmParams ({ commit }) {
    commit(types.CLEAR_UTM_PARAM)
  },
  setUtmSignupMethod ({ commit }, { signupMethod }) {
    commit(types.SET_UTM_SIGNUP_METHOD, signupMethod)
  },
  trackUserSignup ({ commit, state, rootState }) {
    if (!state.utmTracked) {
      const params = {
        ...state.data,
        userId: rootState.user.user.id,
        action: rootState.modals.data.login.source || '',
        path: window.location.pathname
      }
      tracking.trackUserSignup(params).then(() => {
        commit(types.SET_UTM_TRACKED)
      })
    }
  }
}

const mutations = {
  [types.INITIALIZE_UTM_FROM_LOCAL_STORAGE] (state) {
    const utmParams = JSON.parse(localStorage.get(UTM_PARAMS_KEY) || '{}')
    if (utmParams) {
      state.data = utmParams
    }

    if (localStorage.get(UTM_TRACKED_KEY)) {
      state.utmTracked = true
    }
  },
  [types.SET_UTM_PARAM] (state, data) {
    state.data = data
    localStorage.set(UTM_PARAMS_KEY, JSON.stringify(data))
  },
  [types.CLEAR_UTM_PARAM] (state) {
    state.data = {
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmTerm: null,
      utmContent: null,
      action: null,
      signupMethod: null,
      query: null,
      userAgent: null,
      referrer: null
    }
    state.utmTracked = false
    localStorage.remove(UTM_PARAMS_KEY)
    localStorage.remove(UTM_TRACKED_KEY)
  },
  [types.SET_UTM_SIGNUP_METHOD] (state, data) {
    state.data.signupMethod = data
    localStorage.set(UTM_PARAMS_KEY, JSON.stringify(state))
  },
  [types.SET_UTM_TRACKED] (state) {
    state.utmTracked = true
    localStorage.set(UTM_TRACKED_KEY, true)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
